define("shared/components/shared/profile-categorization/categorize-steps/progress-bar/template", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/template-factory"eaimeta@70e063a35619d71f

  var _default = (0, _templateFactory.createTemplateFactory)({
    "id": "XHMnX4OF",
    "block": "[[[10,0],[14,0,\"tSC--avatar u--m__b__xs\"],[12],[1,\"\\n  \"],[10,\"img\"],[14,0,\"tSC--avatar__img\"],[15,\"src\",[28,[37,0],[\"/assets/images/img--signUp--ig\",[30,1],\".svg\"],null]],[12],[13],[1,\"\\n  \"],[10,\"svg\"],[12],[1,\"\\n    \"],[10,\"circle\"],[14,0,\"tSC--avatar__circle\"],[14,\"cx\",\"33\"],[14,\"cy\",\"33\"],[14,\"r\",\"30\"],[12],[13],[1,\"\\n    \"],[10,\"circle\"],[15,0,[28,[37,0],[\"tSC--avatar__loader \",[30,0,[\"progressClass\"]]],null]],[14,\"cx\",\"33\"],[14,\"cy\",\"33\"],[14,\"r\",\"30\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@profileType\"],false,[\"concat\"]]",
    "moduleName": "shared/components/shared/profile-categorization/categorize-steps/progress-bar/template.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});